import { GroupedMedsHistory, IMedicationHistoryItem } from '@store/Meds/types'

/**
 * Groups medication history by day, month, and year.
 *
 * @param {Record<string, IMedicationHistoryItem[]>} historyObject Object with date keys and arrays of medication history items.
 * @returns An object with histories grouped by day, month, and year.
 */
const mapMedicationHistory = (
  historyObject: Record<string, IMedicationHistoryItem[]>
): GroupedMedsHistory => {
  const groupedHistory: GroupedMedsHistory = {}

  Object.entries(historyObject).forEach(([dateString, historyItems]) => {
    const date = dateString || ''
    const match = date.match(/(\d{4})-(\d{2})-(\d{2})/)
    if (match) {
      const year = match[1]
      const month = match[2]
      const day = match[3]

      groupedHistory[year] = groupedHistory[year] || {}
      groupedHistory[year][month] = groupedHistory[year][month] || {}
      groupedHistory[year][month][day] = groupedHistory[year][month][day] || []

      historyItems.forEach(item => groupedHistory[year][month][day].push(item))
    }
  })

  return groupedHistory
}

export default mapMedicationHistory
